import Router from "vue-router";

// router setup
import routes from "../routes/routes";
import Progress from "../_helpers/progress";

import { getJwtToken, getUserSession } from "./localstorage";

export const router = new Router({
  mode: "history",
  routes,
  linkExactActiveClass: "nav-item active"
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login"];
  const authRequired = !publicPages.includes(to.path);
  const currentUser = getUserSession();
  const currentToken = getJwtToken();

  const validSession = currentUser
    && currentUser.token
    && currentToken;

  if (authRequired && !validSession) {
    return next({
      path: "/login",
      query: { returnUrl: to.path }
    });
  }

  next();
});

router.beforeEach((to, from, next) => {
  Progress.start();
  next();
});

router.afterEach((to, from) => {
  window.scrollTo({
    top: 0,
    left: 0,
  });
  Progress.stop();
});
